import type { AdminSession } from '@/services/auth.service';
import {
  ROLE_PERMISSIONS,
  findMockUserByCredentials,
  type PainelMockUser,
} from '@/lib/painel-rbac';

export const DEV_AUTH_TOKEN = 'dev:local';
export const DEV_SESSION_STORAGE_KEY = 'xat_jwt_session';

/** Ativo apenas com `VITE_DEV_AUTH=true` explícito no `.env`. */
export function isDevAuthEnabled(): boolean {
  return import.meta.env.VITE_DEV_AUTH === 'true';
}

export function isDevAuthToken(token: string | null | undefined): boolean {
  return token === DEV_AUTH_TOKEN;
}

export function mockUserToSession(user: PainelMockUser): AdminSession {
  return {
    username: user.username,
    role: user.role,
    name: user.name,
    email: user.email,
    permissions: ROLE_PERMISSIONS[user.role],
  };
}

export function readDevSession(): AdminSession | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(DEV_SESSION_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminSession;
  } catch {
    return null;
  }
}

export function establishDevSession(user: PainelMockUser): AdminSession {
  const session = mockUserToSession(user);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(DEV_SESSION_STORAGE_KEY, JSON.stringify(session));
  }
  return session;
}

export function clearDevSession(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(DEV_SESSION_STORAGE_KEY);
}

export function tryDevLogin(username: string, password: string): AdminSession | null {
  if (!isDevAuthEnabled()) return null;
  const mock = findMockUserByCredentials(username, password);
  if (!mock || mock.status !== 'active') return null;
  return establishDevSession(mock);
}
